import { render, staticRenderFns } from "./ApiKeys.vue?vue&type=template&id=532cdeb4"
import script from "./ApiKeys.vue?vue&type=script&lang=ts"
export * from "./ApiKeys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532cdeb4')) {
      api.createRecord('532cdeb4', component.options)
    } else {
      api.reload('532cdeb4', component.options)
    }
    module.hot.accept("./ApiKeys.vue?vue&type=template&id=532cdeb4", function () {
      api.rerender('532cdeb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ApiKeys.vue"
export default component.exports